import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/logo.gif'


const _withScopeId = n => (_pushScopeId("data-v-65138cf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-header" }
const _hoisted_2 = { class: "g-header_inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "マイナビ転職AGENT"
}, null, -1))
const _hoisted_4 = { class: "u-mn-hidden" }
const _hoisted_5 = { class: "g-header_menu" }
const _hoisted_6 = { class: "g-menu js-gMenu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ホーム", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "応募管理", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求人一覧", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "気になる", -1))
const _hoisted_11 = ["aria-expanded"]
const _hoisted_12 = ["aria-hidden"]
const _hoisted_13 = { class: "g-menu-content_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-content_heading" }, "職務経歴書・履歴書", -1))
const _hoisted_15 = { class: "g-menu-content_buttonWrap" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"g-menu-content_item\" data-v-65138cf7><p class=\"g-menu-content_heading\" data-v-65138cf7>ヘルプ</p><div class=\"g-menu-content_buttonWrap\" data-v-65138cf7><a class=\"g-menu-content_button\" href=\"https://mynavi-agent.jp/pdf/agent_mypage_guide_v2.pdf?d=20251217\" target=\"_blank\" data-v-65138cf7> マイページの使い方 </a><a class=\"g-menu-content_button\" href=\"https://mynavi-agent.jp/service/faq/mynavi/?_ga=2.102996160.1911803075.1728259978-1320162464.1723186724\" target=\"_blank\" data-v-65138cf7> FAQ </a></div></div>", 1)
const _hoisted_17 = { class: "g-menu-content_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-content_heading" }, "設定", -1))
const _hoisted_19 = { class: "g-menu-content_buttonWrap" }
const _hoisted_20 = { class: "g-menu-content_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-content_heading" }, "転職ノウハウ", -1))
const _hoisted_22 = { class: "g-menu-content_buttonWrap" }
const _hoisted_23 = { class: "g-menu-content_item -full" }
const _hoisted_24 = ["aria-hidden"]
const _hoisted_25 = { class: "g-menu-logout_inner" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "g-menu-logout_heading" }, "ログアウトしますか？", -1))
const _hoisted_27 = ["onClick"]

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { postAuthLogout } from '@/api/accountEndpoint';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMyPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();

// Mobile mode
const titleConfig = [
    { path: ['pending'], title: '気になるリスト' },
    { path: ['refusallist'], title: '応募しない求人一覧' },
];
const isDeviceModeTitleVisible = ref<boolean>(false);
const deviceModeTitle = ref<string>('');

// Track open/close of menu and logout dialog
const menuOpen = ref(false);
const showLogoutConfirmDialog = ref(false);

// For changing menu button text
const menuButtonText = computed(() => (menuOpen.value ? 'とじる' : 'メニュー'));

// Optional: track the menu button for focus management
const menuButtonRef = ref<HTMLElement | null>(null);
const menuContentRef = ref<HTMLElement | null>(null);

// Menu config for active highlighting
const menuConfig = [
    { path: ['news'], class: '-home' },
    { path: ['apply'], class: '-id' },
    { path: ['jobsearch', 'refusal', 'refusallist'], class: '-search' },
    { path: ['pending'], class: '-fav' },
    { path: ['profile', 'recommend', 'resume', 'sendsetting', 'pwupdate', 'video'], class: '-menu' },
];

/**
 * Updates the device mode title based on the current route path.
 * If the route segment is missing, shows the home title.
 */
const updateDeviceModeTitle = () => {
    const pathArr = route.path.split('/');
    const section = pathArr[1];

    // If section is null, undefined, or empty, show ''
    if (!section) {
        isDeviceModeTitleVisible.value = false;
        deviceModeTitle.value = '';
        return;
    }

    // Find the matching config for the current section
    const found = titleConfig.find((cfg) => cfg.path.includes(section));

    if (found) {
        isDeviceModeTitleVisible.value = true;
        deviceModeTitle.value = found.title;
    } else {
        // If no match, hide the title
        isDeviceModeTitleVisible.value = false;
        deviceModeTitle.value = '';
    }
};

// Compute which menu is active based on current route
const activeMenuClass = computed(() => {
    let path = route.path;
    // check if path is order detail
    if(route.name == 'g00' || route.name == 'g01')
    {        
        const previousRouteName = store.getters['router/previousRoute']?.path ?? '';
        if(previousRouteName)
            path = previousRouteName;
    }
    const pathArr = path.split('/');
    if (!pathArr[1]) return '-home';
    if ((pathArr[1] === 'apply' || pathArr[1] === 'refusal') && (pathArr[2] === 'form' || pathArr[2] === 'multiple')) {
        return '-searchTMP'; // NOTE QA
    }
    const found = menuConfig.find((cfg) => cfg.path.includes(pathArr[1]));
    return found ? found.class : '';
});

const isMenuButtonActive = computed(() => {
    const pathArr = route.path.split('/');
    return ['profile', 'recommend', 'resume', 'sendsetting', 'pwupdate', 'video'].includes(pathArr[1]);
});

const handleMenuContentClick = (event: MouseEvent) => {
    let el = event.target as HTMLElement | null;
    while (el && el !== menuContentRef.value) {
        if (el.tagName === 'A' && el.classList.contains('g-menu-content_button')) {
            const to = el.getAttribute('href') || el.getAttribute('to');
            if (to && to.startsWith('/') && to === window.location.pathname) {
                menuOpen.value = false;
                break;
            }
        }
        el = el.parentElement;
    }
};

// Toggle menu modal open/close
const toggleMenu = () => {
    // Don't close menu if logout dialog is open
    if (showLogoutConfirmDialog.value) return;
    menuOpen.value = !menuOpen.value;
    document.body.style.overflow = menuOpen.value ? 'hidden' : '';
};

// Logout logic
const handleLogout = async () => {
    try {
        await postAuthLogout();
        store.dispatch('careerId/clear');
        store.dispatch('mailSecurity/clear');
        store.dispatch('mailSecurity/clearHomePopupDismissed');
        store.commit('router/initLoginTransitionData');
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'logout',
                career_id: undefined
            });
        }
        router.push({ name: 'a10' });
    } catch (error) {
        console.error(error);
    }
};

onMounted(() => {
    if (menuContentRef.value) {
        menuContentRef.value.addEventListener('click', handleMenuContentClick);
    }
});

onBeforeUnmount(() => {
    if (menuContentRef.value) {
        menuContentRef.value.removeEventListener('click', handleMenuContentClick);
    }
});

// Watch for route changes to update device mode title and handle menu state
watch(
    () => route.fullPath,
    () => {
        updateDeviceModeTitle();
        if (menuOpen.value) {
            toggleMenu();
        }
    },
    {immediate: true}
);
// Add watcher for menuOpen to handle menuButtonText change event
watch(menuOpen, () => {
  // This will be triggered whenever menuOpen changes
    if (menuButtonText.value === 'メニュー') {
        document.body.style.overflow = '';
    }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["l-wrapper_header", { 'is-apply-close': _unref(route).meta.header === 'sp-none' }])
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "g-header_logo",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("nav", _hoisted_6, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["g-menu_button -home", { 'is-active': _unref(activeMenuClass) === '-home' }]),
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["g-menu_button -id", { 'is-active': _unref(activeMenuClass) === '-id' }]),
                  to: "/apply/"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["g-menu_button -search", { 'is-active': _unref(activeMenuClass) === '-search' }]),
                  to: "/jobsearch/"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["g-menu_button -fav", { 'is-active': _unref(activeMenuClass) === '-fav' }]),
                  to: "/pending/"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createElementVNode("button", {
                  ref_key: "menuButtonRef",
                  ref: menuButtonRef,
                  class: _normalizeClass(["g-menu_button -menu js-gMenu-button", { 'is-active': _unref(isMenuButtonActive) }]),
                  "aria-expanded": menuOpen.value,
                  "aria-controls": "g-menu-head",
                  onClick: toggleMenu
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(menuButtonText)), 1)
                ], 10, _hoisted_11),
                _createElementVNode("div", {
                  class: "g-menu-content js-gMenu-content",
                  id: "g-menu-head",
                  "aria-hidden": !menuOpen.value,
                  ref_key: "menuContentRef",
                  ref: menuContentRef,
                  onClick: toggleMenu
                }, [
                  _createElementVNode("div", {
                    class: "g-menu-content_inner",
                    onClick: _cache[1] || (_cache[1] = ($event) => $event.stopPropagation())
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          class: "g-menu-content_button",
                          to: "/resume/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("書類作成")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          class: "g-menu-content_button",
                          to: "/sendsetting/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("配信設定")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          class: "g-menu-content_button",
                          to: "/pwupdate/form/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("パスワード更新")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          class: "g-menu-content_button",
                          to: "/mail_security/form"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("ログインID・メールアドレス変更")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          class: "g-menu-content_button",
                          to: "/video/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("転職活動ノウハウ動画")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("button", {
                        class: "g-menu-content_button -logout js-gMenu-logout-button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (showLogoutConfirmDialog.value = true)),
                        "aria-controls": "g-menu-logout-head"
                      }, " ログアウト ")
                    ])
                  ])
                ], 8, _hoisted_12),
                _withDirectives(_createElementVNode("div", {
                  class: "g-menu-logout js-gMenu-logout-content",
                  id: "g-menu-logout-head",
                  "aria-hidden": !showLogoutConfirmDialog.value
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showLogoutConfirmDialog.value = false)),
                      class: "g-menu-logout_close js-gMenu-close",
                      "aria-label": "キャンセル"
                    }),
                    _hoisted_26,
                    _createElementVNode("button", {
                      onClick: _withModifiers(handleLogout, ["stop"]),
                      class: "g-menu-logout_button"
                    }, "ログアウトする", 8, _hoisted_27),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showLogoutConfirmDialog.value = false)),
                      class: "g-menu-logout_cancel js-gMenu-close"
                    }, "キャンセル")
                  ])
                ], 8, _hoisted_24), [
                  [_vShow, showLogoutConfirmDialog.value]
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _withDirectives(_createElementVNode("h1", { class: "p-pending_tit_sp" }, _toDisplayString(deviceModeTitle.value), 513), [
      [_vShow, isDeviceModeTitleVisible.value]
    ])
  ], 64))
}
}

})